import React from 'react';
import styled, { css } from 'styled-components';
import AboutImg from '../Assests/about.png';

const glass = css`
  backdrop-filter: blur(26px) saturate(175%) brightness(1.03);
  -webkit-backdrop-filter: blur(26px) saturate(175%) brightness(1.03);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.14), rgba(255,255,255,0.04)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.55), rgba(255,255,255,0.18), rgba(139,29,29,0.16)) border-box;

  box-shadow:
    0 18px 55px rgba(0,0,0,0.12),
    inset 0 1px 0 rgba(255,255,255,0.35);
`;

const glassSoft = css`
  backdrop-filter: blur(18px) saturate(165%) brightness(1.02);
  -webkit-backdrop-filter: blur(18px) saturate(165%) brightness(1.02);

  border: 1px solid transparent;
  background:
    linear-gradient(135deg, rgba(255,255,255,0.12), rgba(255,255,255,0.03)) padding-box,
    linear-gradient(135deg, rgba(246,201,69,0.45), rgba(255,255,255,0.16), rgba(139,29,29,0.14)) border-box;

  box-shadow:
    0 14px 45px rgba(0,0,0,0.10),
    inset 0 1px 0 rgba(255,255,255,0.28);
`;

const AboutSection = () => {
  return (
    <Section id="about">
      <Shell>
        <Header>
          <Title>About</Title>
          <Subtitle>Community-driven Baybayin tools, culture, and creative collaboration.</Subtitle>
        </Header>

        <Card>
          <Grid>
            <Media>
              <MediaFrame>
                <img src={AboutImg} alt="About illustration" />
              </MediaFrame>
            </Media>

            <Body>
              <BodyTitle>
                <Brand>eBaybayMo</Brand> — Baybayin for creators and learners
              </BodyTitle>
              <Description>
                <Brand>eBaybayMo</Brand> is a community-driven app that uses technology to bring Baybayin characters to
                life, connecting tattoo artists, t-shirt designers, scholars, and enthusiasts with the rich heritage of
                the Filipino script.
              </Description>

              <Pills>
                <Pill>Merch</Pill>
                <Pill>Baybayin</Pill>
                <Pill>Culture</Pill>
              </Pills>
            </Body>
          </Grid>
        </Card>
      </Shell>
    </Section>
  );
};

export default AboutSection;

/* ---------- Styles ---------- */

const Section = styled.section`
  min-height: 100vh;
  padding: 5.5rem 1rem 4rem;
  position: relative;
  background: transparent;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    width: 720px;
    height: 720px;
    left: -320px;
    bottom: -340px;
    background: radial-gradient(circle at 35% 35%, rgba(139,29,29,0.16), transparent 62%);
    filter: blur(70px);
    opacity: 0.9;
    pointer-events: none;
  }

  &::after {
    content: '';
    position: absolute;
    width: 760px;
    height: 760px;
    right: -340px;
    top: 100px;
    background: radial-gradient(circle at 40% 40%, rgba(246,201,69,0.14), transparent 62%);
    filter: blur(80px);
    opacity: 0.9;
    pointer-events: none;
  }
`;

const Shell = styled.div`
  max-width: 1180px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 1.6rem;
`;

const Title = styled.h2`
  margin: 0;
  font-family: 'Poppins', sans-serif;
  font-weight: 1000;
  font-size: clamp(2rem, 3.2vw, 2.6rem);
  color: #8b1d1d;
  letter-spacing: -0.02em;
`;

const Subtitle = styled.p`
  margin: 0.55rem auto 0;
  max-width: 820px;
  font-family: 'Poppins', sans-serif;
  color: rgba(32, 21, 21, 0.70);
  font-size: 1.05rem;
`;

const Card = styled.div`
  ${glass}
  border-radius: 24px;
  padding: 1.35rem;
  max-width: 10000px;
  margin: 0 auto;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 420px 1fr;
  gap: 1.25rem;
  align-items: center;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const Media = styled.div`
  display: flex;
  justify-content: center;
`;

const MediaFrame = styled.div`
  ${glassSoft}
  border-radius: 24px;
  padding: 0.85rem;
  width: 100%;
  max-width: 450px;

  img {
    width: 100%;
    height: auto;
    display: block;
    border-radius: 14px;
    transition: transform 0.25s ease;
  }

  &:hover img {
    transform: scale(1.02);
  }
`;

const Body = styled.div`
  text-align: left;

  @media (max-width: 980px) {
    text-align: center;
  }
`;

const BodyTitle = styled.h3`
  margin: 0 0 0.8rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 950;
  font-size: 1.45rem;
  color: rgba(32, 21, 21, 0.88);
`;

const Brand = styled.span`
  color: #8b1d1d;
  font-style: italic;
  font-weight: 1000;
`;

const Description = styled.p`
  margin: 0 0 1rem;
  font-family: 'Poppins', sans-serif;
  font-size: 1.08rem;
  line-height: 1.65;
  color: rgba(32, 21, 21, 0.78);
  max-width: 820px;
`;

const Pills = styled.div`
  display: flex;
  gap: 0.6rem;
  flex-wrap: wrap;

  @media (max-width: 980px) {
    justify-content: center;
  }
`;

const Pill = styled.span`
  ${glassSoft}
  border-radius: 999px;
  padding: 0.65rem 0.95rem;
  font-family: 'Poppins', sans-serif;
  font-weight: 900;
  font-size: 0.95rem;
  color: rgba(139, 29, 29, 0.92);
`;
